var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator-wrapper",attrs:{"id":`quality-indicator-${_vm.callId}`}},_vm._l((_vm.indicatorBarsConfig),function(bar,index){return _c('div',{key:bar,staticClass:"indicator-item",class:{filled: _vm.value >= bar, 'low-quality': _vm.value >= bar && _vm.value < _vm.LOW_QUALITY_VALUE},style:({height: `${(index + 1) * 4}px`})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }